import { createRouter, createWebHashHistory } from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

/* Layout */
import Layout from '../views/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [{
        path: '/install',
        component: () =>
            import ('@/views/sys/install/index'),
        meta: {
            title: '安装管理后端',
            content: {
                keywords: 'QShop商城安装管理后端',
                description: 'QShop商城安装管理后端',
            },
        },
        hidden: true
    }, {
        path: '/login',
        component: () =>
            import ('@/views/sys/login/index'),
        meta: {
            title: '登录',
            content: {
                keywords: 'QShop登录页',
                description: 'QShop登录页',
            },
        },
        hidden: true
    },
    {
        path: '/404',
        component: () =>
            import ('@/views/sys/errorPage/404'),
        meta: {
            sortNo: 0
        },
        hidden: true
    },
    {
        path: '/401',
        component: () =>
            import ('@/views/sys/errorPage/401'),
        meta: {
            sortNo: 0
        },
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        // VR4 相对 redirect 是相对"当前所在路由"解析的（VR3 相对当前路由记录），
        // 在 /store/storesettingpay 下触发会拼成 /store/dashboard，必须写绝对路径
        redirect: '/dashboard',
        name: 'layout',
        meta: {
            sortNo: 0
        },
        children: [{
                path: '/dashboard',
                name: 'dashboard',
                meta: {
                    title: '主页',
                    icon: 'iconfont icon-zhuyeicon',
                    sortNo: 0
                },
                component: () =>
                    import ('@/views/sys/dashboard/index')
            }, {
                path: '/profile',
                name: 'profile',
                hidden: true,
                meta: {
                    title: '个人中心',
                    icon: 'guide',
                    sortNo: 0
                },
                component: () =>
                    import ('@/views/user/adminuser/profile')
            },

            // {
            // // path: '/iframePage/:url/:name',
            // path: '/iframePage/:code',
            // name: 'iframePage',
            // hidden: true,
            // meta: {
            //     title: '接口文档',
            //     icon: 'guide',
            //     sortNo: 0
            // },
            // component: () =>
            //     import ('@/views/iframePage/index')
            // }
        ]
    },
    // {
    //   path: '/',
    //   hidden: true,
    //   component: Layout,
    //   meta: { sortNo: 0 },
    //   children: [{
    //     path: '/profile',
    //     name: 'profile',
    //     meta: { title: '个人中心', icon: 'guide', sortNo: 0 },
    //     component: () => import('@/views/user/adminuser/profile')
    //   }]
    // }
    // {
    //   path: '/swagger',
    //   component: Layout,
    //   meta: { sortNo: 0 },
    //   children: [{
    //     path: '',
    //     name: 'swagger',
    //     meta: { title: '接口文档', icon: 'guide', sortNo: 0 },
    //     component: () => import('@/views/swagger/index')
    //   }]
    // }

    //商品编辑路由
    {
        path: '/goods',
        component: Layout,
        redirect: 'noredirect',
        name: 'goods',
        meta: {
            title: '商品',
            icon: 'eye',
        },
        children: [{
            path: 'edit/:id?',
            component: () =>
                import ('@/views/goods/goods/edit'),
            name: 'goodsEdit',
            meta: {
                title: '新增/编辑商品',
            },
        }, ],
    },
    //订单详情路由
    {
        path: '/order',
        component: Layout,
        redirect: 'noredirect',
        name: 'order',
        meta: {
            title: '订单',
        },
        children: [{
                path: 'details/:id',
                component: () =>
                    import ('@/views/order/order/details'),
                name: 'orderDetail',
                meta: {
                    title: '订单详情',
                },
            },
            {
                path: "refundDetails",
                component: () =>
                    import ("@/views/order/order/refundDetails"),
                name: "refundDetails",
                hidden: true,
                meta: {
                    notauth: true,
                    title: "售后订单详情",
                    noCache: true,
                    icon: "list",
                },
            },
        ],
    },
    //病历编辑路由
    {
        path: '/medicalrecord',
        component: Layout,
        redirect: 'noredirect',
        name: 'medicalrecord',
        meta: {
            title: '病历',
        },
        children: [{
            path: 'edit/:id?',
            component: () =>
                import ('@/views/medicalrecord/edit'),
            name: 'medicalrecordEdit',
            meta: {
                title: '新增/编辑病历',
            },
        }, ],
    },
    //文章编辑路由
    {
        path: '/article',
        component: Layout,
        redirect: 'noredirect',
        name: 'article',
        meta: {
            title: '文章',
        },
        children: [{
            path: 'edit/:id?',
            component: () =>
                import ('@/views/article/edit'),
            name: 'articleEdit',
            meta: {
                title: '新增/编辑文章',
            },
        }, ],
    },
    //配镜订单编辑路由
    {
        path: '/lensorder',
        component: Layout,
        redirect: 'noredirect',
        name: 'lensorder',
        meta: {
            title: '配镜订单',
        },
        children: [{
            path: 'edit/:id?',
            component: () =>
                import ('@/views/lensorder/edit'),
            name: 'lensorderEdit',
            meta: {
                title: '新增/编辑配镜订单',
            },
        }, {
            path: 'lensreplaceedit/:id?',
            component: () =>
                import ('@/views/lensorder/lensreplaceedit'),
            name: 'lensreplaceEdit',
            meta: {
                title: '新增/编辑补换镜片订单',
            },
        }, ],
    },
    {
        path: '/servicerecord',
        component: Layout,
        redirect: 'noredirect',
        name: 'serviceRecord',
        meta: {
            title: '服务记录',
        },
        children: [{
            path: 'edit/:id?',
            component: () =>
                import ('@/views/servicerecord/edit'),
            name: 'serviceRecordEdit',
            meta: {
                title: '新增/编辑服务记录',
            },
        }, ],
    },
    // VR4 兜底路由：刷新/直达动态菜单路径时，首次导航发生在 permission.js 的 addRoute 之前，
    // 没有 catch-all 会报 "No match found" 警告。guard 在 addRoute 后用 next({...to, replace: true})
    // 重新导航即可命中真实路由；这里不能写 redirect: '/404'（VR4 的 redirect 会改写 guard 拿到的
    // to，导致刷新后落到 404），静态渲染 404 组件即可——真正未知的路径最终也会停留在这。
    {
        path: '/:pathMatch(.*)*',
        component: () =>
            import ('@/views/sys/errorPage/404'),
        hidden: true,
    },
]

var router = createRouter({
    history: createWebHashHistory(), //原 mode 未启用 history，保持 hash 模式
    scrollBehavior: () => ({
        left: 0,
        top: 0
    }),
    routes: constantRouterMap
})

export default router